'use strict';
import formatter 		from './../helpers/formater';

export default {
	START_NEW_RESERVATION({dispatch, rootGetters,getters, commit}) {
		console.debug('A|orm/reservation/START_NEW_RESERVATION');
		commit('UNSET_STATION');
		commit('UNSET_STARTDATE');
		commit('UNSET_ENDDATE');
		commit('UNSET_CAR');
		commit('SET_NAVIGATION', true);
	},

	GET_RENTALTYPES({dispatch, rootGetters,getters, commit}, sid) {
		var $vm = this._vm;

		console.debug('ORM|A|GET_RENTALTYPES');
		return $vm.$api
			.get('/api/rentaltypes', {
				params: {
					sid: getters.sid
				}
			})
			.then(response => {
				return response.data;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	MAKE_RESERVATION({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm,
			currentTime = new Date().getTime();
		console.debug('A|orm/reservation/MAKE_RESERVATION');
		console.warn('ORM|A|MAKE_RESERVATION @todo formdata richtig machen!');

		let form = new FormData();
		form.set('startStationKey', getters.startstation.station);
		form.set('returnStationKey', getters.startstation.station);
		form.set('startDate', formatter.API_DATE(getters.startdate));
		form.set('endDate', formatter.API_DATE(getters.enddate));
		form.set('groupKey', getters.car.groupKey);
		form.set('typeOfRental', getters.rentaltype);
		form.set('comment', getters.rentalcomment);
		form.set('billKey', getters.car.billKey);
		form.set('voucher', getters.voucher);

		form.set('sid', getters.sid);

		 if(getters.estimated_km && getters.estimated_km > 0) form.set('estimatedKm', getters.estimated_km);

		return $vm.$api
		.post('/api/carsharing/reservate', form)
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;

				return (response.data.success ? response.data.result : Promise.reject(new Error('Cant Reservate')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});  
	},

	SET_STATION_BY_KEY({dispatch, rootGetters,getters, commit}, station_key) {
		console.debug('A|orm/reservation//SET_STATION_BY_KEY');
		commit('SET_STATION', rootGetters['orm/station'](station_key))
	},


	CANCEL_RESERVATION({dispatch, rootGetters, getters, commit}, reservation_id) {
		var $vm = this._vm;

		let form = new FormData();
		//form.set('id', reservation_id);
		form.set('sid', getters.sid);		

		return $vm.$api
		.delete('/api/customer/reservation/cancel', {params: {sid: getters.sid}, data: {id: reservation_id}})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;

				return (response.data.success ? response.data.result : Promise.reject(new Error('Cant Cancel Reservation')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},
};



// WEBPACK FOOTER //
// ./src/store/orm/reservation/actions.js